import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { motion } from "framer-motion";
import {
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
} from "react-icons/fa";

// پس زمینه متحرک
const icons = [
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
];

const staticBackgroundIcons = (() => {
  const rows = 5,
    cols = 11,
    arr = [];
  for (let i = 0; i < rows; i++)
    for (let j = 0; j < cols; j++) {
      const Icon = icons[Math.floor(Math.random() * icons.length)];
      arr.push({
        Icon,
        size: 18 + Math.random() * 20,
        top: (i / rows) * 100 + Math.random() * 5,
        left: (j / cols) * 100 + Math.random() * 5,
        duration: 12 + Math.random() * 10,
        opacity: 0.15 + Math.random() * 0.25,
        xOffset: Math.random() * 10 - 5,
        yOffset: Math.random() * 10 - 5,
      });
    }
  return arr;
})();

const AnimatedBackground = React.memo(() => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    {staticBackgroundIcons.map((item, i) => (
      <motion.div
        key={i}
        className="absolute text-white/50"
        style={{
          top: `${item.top}%`,
          left: `${item.left}%`,
          opacity: item.opacity,
        }}
        initial={{ scale: 0.5 }}
        animate={{
          x: [0, item.xOffset, 0],
          y: [0, item.yOffset, 0],
          scale: [0.5, 1, 0.5],
        }}
        transition={{
          duration: item.duration,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <item.Icon size={item.size} />
      </motion.div>
    ))}
  </div>
));

const LoginForm = () => {

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_URL;

  const handleLogin = async () => {
    if (!email || !password)
      return toast.error("ایمیل و رمز عبور را وارد کنید");

    try {
      setLoading(true);
      const res = await axios.post(`${API_BASE}/api/Auth/Login`, {
        email,
        password,
      });
      toast.success("خوش آمدید!");
      localStorage.setItem("token", res.data.data);
      navigate("/Mainpage");
    } catch (err) {
      toast.error(err?.response?.data?.message || "خطا در ورود");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen w-full bg-gray-800 flex items-center justify-center overflow-hidden">
      <AnimatedBackground />

      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="backdrop-blur-xl bg-white/90 border border-white/30 shadow-2xl rounded-2xl p-10 w-full max-w-md mx-4 relative z-10"
      >
        <h1 className="text-center text-3xl font-iranSansNormal text-gray-800 mb-10">
          ورود به پنل مدیریت
        </h1>

        <div className="space-y-6">
          {/* ایمیل */}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="ایمیل"
            className="w-full h-14 px-6 bg-white/70 rounded-xl border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-bold shadow-sm transition-all placeholder-gray-500"
          />

          {/* رمز عبور */}
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="رمز عبور"
              className="w-full h-14 px-6 bg-white/70 rounded-xl border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-bold shadow-sm transition-all placeholder-gray-500"
            />
            {password && (
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-600 hover:text-gray-800 transition"
              >
                {showPassword ? (
                  <AiOutlineEyeInvisible size={24} />
                ) : (
                  <AiOutlineEye size={24} />
                )}
              </button>
            )}
          </div>

          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            disabled={loading}
            onClick={handleLogin}
            className="w-full py-4 bg-gray-800 hover:bg-gray-900 text-white font-iranSansNormal text-xl rounded-xl shadow-2xl transition-all duration-300 mt-4"
          >
            {loading ?
                "در حال تایید ..."
                :
                "ورود"
            }

          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginForm;
